import { MenuItem } from 'vue-graphql-models';

export default [

  new MenuItem({
    id: 'createNewUser',
    title: 'Create New User',
    subtitle: 'Add New User',
    route: { name: 'createNewUser' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'userHelp',
    title: 'Help',
    subtitle: 'How to\'s and Contact Info',
    customIcon: true,
    icon: 'dhc-help',
  }),
  new MenuItem({
    id: 'userEdit',
    title: 'Edit User',
    subtitle: 'Edit User Details',
    route: { name: 'userEdit' },
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'editUserAssets',
    title: 'Edit User Assets',
    subtitle: 'Add/Remove User to Assets',
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'userDelete',
    title: 'Delete User',
    subtitle: 'Remove User Record',
    customIcon: true,
    icon: 'dhc-trash',
  }),
  new MenuItem({
    id: 'userClone',
    title: 'Clone User',
    subtitle: 'Clone User Details',
    route: { name: 'users' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'usersHelp',
    title: 'Help',
    subtitle: 'How to\'s and Contact Info',
    customIcon: true,
    icon: 'dhc-help',
  }),
];
